import * as React from 'react';

import PageBannerModule from 'bundles/unified-description-page-common/components/modules/page-banner/PageBannerModule';
import Markdown from 'bundles/unified-description-page-common/components/shared/Markdown';
import type { SelfServeConfigPageBannerModuleFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationMarketingPageQuery';

type Props = {
  config?: SelfServeConfigPageBannerModuleFragment & {
    staticMessage?: React.ReactNode;
  };
};

export const shouldRenderPageBannerModuleRenderer = ({ config }: Props) => {
  if (config?.staticMessage) {
    return true;
  }

  if (config?.message == null) {
    return false;
  }

  return true;
};

const PageBannerModuleRenderer = ({ config }: Props) => {
  if (config?.staticMessage) {
    return <PageBannerModule message={config.staticMessage} />;
  }

  if (config?.message == null) {
    return null;
  }

  return <PageBannerModule message={<Markdown source={config.message} />} />;
};

export default PageBannerModuleRenderer;
